// to sort list of records on basis of date in descending order
export function sortRecordsOnDate(listOfRecords: any[], dateAttribute: string){
    return listOfRecords.sort((a, b) => {
        const dateA = new Date(`${a[dateAttribute]}`).valueOf();
        const dateB = new Date(`${b[dateAttribute]}`).valueOf();
        if (dateA > dateB) {
            return -1;
        }
        return 1
    });
}
export interface TpTaxUIFilter {
    entity?: string;
    cli?: string;
    periodName?: string;
    accountingDay?:string;

};
export const parseTpTaxUIFilter = (filter: string) => {
    const filterObject: TpTaxUIFilter = {};
    if(filter === 'undefined' || filter === '' || filter === '++') {
        return filterObject
    } 
    else {
        const filterArray = filter.split('+');
        let cliValue = filterArray[1];
        cliValue = cliValue.replace('*','.');     
        filterObject["periodName"] = filterArray[2];
        filterObject["cli"] = cliValue;
        filterObject["entity"] = filterArray[0];
        filterObject["accountingDay"] = filterArray[3];
        return filterObject;
    }
};

export interface CwbUIFilter {
    workbookLabel?: string;
    period?: string;
    accountingDay?: string;
}

export const parseCwbUIFilter = (filter: string) => {
    const filterObject: CwbUIFilter = {};
    if(filter === 'undefined' || filter === '' || filter === '++') {
        return filterObject
    }
    else {
        const filterArray = filter.split('+');
        filterObject["workbookLabel"] = filterArray[0];
        filterObject["period"] = filterArray[1];
        filterObject["accountingDay"] = filterArray[2];
        return filterObject;
    }
};

export const extractWorkbookIdFromWorkbookLabel = (workbookLabel: string) => {
    const workbookLabelArray = workbookLabel.split(' ');
    return workbookLabelArray[0];
}

export interface LefUIFilter {
    companyCodeLabel?: string;
    period?: string;
    accountingDay?: string;
}

export const parseLefUIFilter = (filter: string) => {
    const filterObject: LefUIFilter = {};
    if(filter === 'undefined' || filter === '' || filter === '++') {
        return filterObject
    }
    else {
        const filterArray = filter.split('+');
        filterObject["companyCodeLabel"] = filterArray[0].replace(/\*/g, '.');
        filterObject["period"] = filterArray[1];
        filterObject["accountingDay"] = filterArray[2];
        return filterObject;
    }
}

export const extractCompanyCodeFromCompanyCodeLabel = (companyCodeLabel: string) => {
    const companyCodeLabelArray = companyCodeLabel.split(' ');
    return companyCodeLabelArray[0];
}

export const createWorkbookLabel = (workbookId: string, workbookName: string): string => `${workbookId} - ${workbookName}`;